import { call, put } from 'redux-saga/effects';
import { getProblemsByFilter, getProblemsStats, downloadProblems } from '../api/problems-service';
import { getResultBySerialAndDate } from '../api/results-service';
import { getByStartDateRange } from '../api/daily-info-service';
import {
  SET_COORDINATES_PROBLEMS,
  SET_COORDINATE_RESULT,
  SET_PROBLEMS_EMPTY_STATE,
  SET_RESULT_EMPTY_STATE,
  SET_DATA_LOADING,
  ADD_COORDINATES_SUCCESS,
  ADD_COORDINATES_FAILURE,
  SET_DOWNLOAD_FAILURE
} from '../reducers/upa-data';
import { SET_NEXT_PAGE } from '../reducers/filters';
import { saveAs } from 'file-saver/FileSaver';

export function* getCoordinatesProblemsSaga({ payload }) {
  yield put({ type: SET_DATA_LOADING, payload: true });
  try {
    const problems = yield call(getProblemsByFilter, payload);
    const dailyInfo = yield call(getByStartDateRange, payload);
    const problemsStats = yield call(getProblemsStats, payload);
    const resultPayload = { problems, dailyInfo, problemsStats };
    yield put({ type: SET_COORDINATES_PROBLEMS, payload: resultPayload });
    yield put({ type: SET_NEXT_PAGE });
  } catch (err) {
    yield put({ type: SET_PROBLEMS_EMPTY_STATE, payload: err });
  } finally {
    yield put({ type: SET_DATA_LOADING, payload: false });
  }
}

export function* addCoordinatesProblemsSaga({ payload }) {
  yield put({ type: SET_DATA_LOADING, payload: true });
  try {
    const problems = yield call(getProblemsByFilter, payload);
    yield put({ type: ADD_COORDINATES_SUCCESS, payload: problems });
    yield put({ type: SET_NEXT_PAGE });
  } catch (err) {
    yield put({ type: ADD_COORDINATES_FAILURE, payload: err });
  } finally {
    yield put({ type: SET_DATA_LOADING, payload: false });
  }
}

export function* getCoordinateResultSaga({ payload }) {
  yield put({ type: SET_DATA_LOADING, payload: true });
  try {
    const result = yield call(getResultBySerialAndDate, payload);
    yield put({ type: SET_COORDINATE_RESULT, payload: { result } });
  } catch (err) {
    yield put({ type: SET_RESULT_EMPTY_STATE, payload: err });
  } finally {
    yield put({ type: SET_DATA_LOADING, payload: false });
  }
}

export function* downloadProblemsSaga({ payload }) {
  yield put({ type: SET_DATA_LOADING, payload: true });
  try {
    const problems = yield call(downloadProblems, payload);
    saveAs(new Blob([problems], {type: 'text/csv'}), 'problemas-' + payload.dateStart.split('-').reverse().join('/') + '--' + payload.dateEnd.split('-').reverse().join('/') + '.csv');
  } catch (err) {
    yield put({ type: SET_DOWNLOAD_FAILURE, payload: err });
  } finally {
    yield put({ type: SET_DATA_LOADING, payload: false });
  }
}


// WEBPACK FOOTER //
// ./src/sagas/load-data.js